export const restrictedData: string[] = ["02"]